/**
 * Enums del dominio del Sistema DPV.
 * Espejo exacto de los enums definidos en el backend (dpv_common.schemas.enums).
 */

export const Rol = {
  ADMINISTRADOR: 'administrador',
  TECNICO_LABORATORIO: 'tecnico_laboratorio',
  PROFESIONAL: 'profesional',
  ESTABLECIMIENTO: 'establecimiento',
} as const;
export type Rol = (typeof Rol)[keyof typeof Rol];

export const TipoProfesional = {
  VETERINARIO: 'veterinario',
  INGENIERO_AGRONOMO: 'ingeniero_agronomo',
  OTRO: 'otro',
} as const;
export type TipoProfesional = (typeof TipoProfesional)[keyof typeof TipoProfesional];

export const CanalEnvio = {
  EMAIL: 'email',
  WHATSAPP: 'whatsapp',
} as const;
export type CanalEnvio = (typeof CanalEnvio)[keyof typeof CanalEnvio];

export const TipoAnalisis = {
  HPG: 'hpg',
  COPROCULTIVO: 'coprocultivo',
  ECTOPARASITOS: 'ectoparasitos',
  BAERMANN: 'baermann',
  SEDIMENTACION_FH: 'sedimentacion_fh',
  OPG: 'opg',
} as const;
export type TipoAnalisis = (typeof TipoAnalisis)[keyof typeof TipoAnalisis];

export const ResultadoBinario = {
  POSITIVO: 'positivo',
  NEGATIVO: 'negativo',
} as const;
export type ResultadoBinario = (typeof ResultadoBinario)[keyof typeof ResultadoBinario];

export const TipoInforme = {
  PARCIAL: 'parcial',
  FINAL: 'final',
} as const;
export type TipoInforme = (typeof TipoInforme)[keyof typeof TipoInforme];

export const TipoDestinatario = {
  PROFESIONAL: 'profesional',
  ADICIONAL: 'adicional',
} as const;
export type TipoDestinatario = (typeof TipoDestinatario)[keyof typeof TipoDestinatario];

export const StatusEnvio = {
  PENDING: 'pending',
  SENT: 'sent',
  ACCEPTED: 'accepted',
  DELIVERED: 'delivered',
  READ: 'read',
  FAILED: 'failed',
} as const;
export type StatusEnvio = (typeof StatusEnvio)[keyof typeof StatusEnvio];

export const StatusGlobal = {
  PENDING: 'pending',
  TODOS_ENVIADOS: 'todos_enviados',
  PARCIAL: 'parcial',
  TODOS_FALLIDOS: 'todos_fallidos',
} as const;
export type StatusGlobal = (typeof StatusGlobal)[keyof typeof StatusGlobal];
